module.exports = __webpack_public_path__ + "static/media/knightBlueNew.24c3887d.svg";